import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const distributeVerticallyMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Distribute vertically',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ refMap }): void => {
			// const { refMap } = appState.ui.contextMenu;
			// console.log('menu-item:distribute-vertically', refMap);
			if (refMap?.panelItemGroup) refMap.panelItemGroup.centerItemsVertically();
		}
	};
};
